import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createNumericTransformer, createTimestampTransformer } from '../common/sql';
import {
  DBOccurrenceRegionSchema,
  DBQuestionOccurrenceSchema,
  OccurrenceRegionSchema,
  QuestionOccurrenceSchema,
} from './schemas';

export const QuestionOccurrenceCodecConfig: TransformerConfig<
  typeof QuestionOccurrenceSchema,
  typeof DBQuestionOccurrenceSchema
> = {
  name: 'QuestionOccurrence',
  clientSchema: QuestionOccurrenceSchema,
  dbSchema: DBQuestionOccurrenceSchema,
  transformers: [
    createTimestampTransformer<typeof QuestionOccurrenceSchema, typeof DBQuestionOccurrenceSchema>(
      'createdAt'
    ),
  ],
};

export const OccurrenceRegionCodecConfig: TransformerConfig<
  typeof OccurrenceRegionSchema,
  typeof DBOccurrenceRegionSchema
> = {
  name: 'OccurrenceRegion',
  clientSchema: OccurrenceRegionSchema,
  dbSchema: DBOccurrenceRegionSchema,
  transformers: [
    ...(['bboxX0', 'bboxY0', 'bboxX1', 'bboxY1'] as const).map(field =>
      createNumericTransformer<typeof OccurrenceRegionSchema, typeof DBOccurrenceRegionSchema>(
        field
      )
    ),
    createTimestampTransformer<typeof OccurrenceRegionSchema, typeof DBOccurrenceRegionSchema>(
      'createdAt'
    ),
  ],
};

export const encodeQuestionOccurrenceToDb = createEncodeToDbFn(QuestionOccurrenceCodecConfig);
export const decodeQuestionOccurrenceFromDb = createDecodeFromDbFn(QuestionOccurrenceCodecConfig);
export const encodeOccurrenceRegionToDb = createEncodeToDbFn(OccurrenceRegionCodecConfig);
export const decodeOccurrenceRegionFromDb = createDecodeFromDbFn(OccurrenceRegionCodecConfig);
